import React, { Fragment, useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Input,
  Row,
  Col,
} from "reactstrap";

import api from "../../components/Tienda/api";
import apifunctions from "../../components/Tienda/api/functions";

import logo from "../../assets/img/TuHogarOnline-circle.png";

export const DescripcionPreciosModal = ({ PrecioBase }) => {
  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);
  const [activeCard, setActiveCart] = useState(0);
  const [tarjetas, setTarjetas] = useState([]);

  useEffect(() => {
    const successCallback = (response) => {
      if (response && Array.isArray(response.data)) {
        setTarjetas(response.data);
        setActiveCart(0);
      } else if (Array.isArray(response)) {
        setTarjetas(response);
        setActiveCart(0);
      }
    };
    const failureCallback = () => setTarjetas([]);
    apifunctions.get(
      api.api.ventas.tarjetasyplanes,
      79,
      null,
      {},
      successCallback,
      failureCallback,
      failureCallback
    );
  }, []);

  // La API puede devolver interes como factor (1.35) o como porcentaje (35)
  const interesFactor = (interes) => {
    if (interes === undefined || interes === null) return 1;
    if (interes === 0) return 1;
    return interes > 5 ? 1 + interes / 100 : interes;
  };

  const cuotasNumero = (cuota) => cuota?.nro ?? cuota?.nroCuotas ?? 1;

  /**
   * Teniendo en cuenta el Ticket #00006969 se realizara la financiacion de las tarjetas sobre el PrecioLista
   * El descuento por pago contado se tendra sobre el precioLista
   * De ser necesario realizar la financiacion sobre el precioContado, tener en cuenta la linea comentada
   */
  const ValorCuota = (interes, nroCuotas) =>
    `$ ${new Intl.NumberFormat("de-DE").format(
      Math.ceil((PrecioBase * interesFactor(interes)) / nroCuotas)
    )}`;
  // const ValorCuota = (interes, nroCuotas, pContado = true) => `$ ${((pContado ? PrecioBase : Precio) * (1 + interes / 100) / nroCuotas))}`;

  const Intereses = (interes) =>
    `$ ${new Intl.NumberFormat().format(
      Math.ceil(PrecioBase * (interesFactor(interes) - 1))
    )}`;
  const TotalFinanciado = (interes) =>
    `$ ${new Intl.NumberFormat().format(
      Math.ceil(PrecioBase * interesFactor(interes))
    )}`;

  // const Intereses = (interes) => `$  ${(PrecioBase * interes / 100)}`;
  // const TotalFinanciado = (interes) => `$ ${(PrecioBase * (1 + interes / 100))}`;

  const tarjetaActiva = tarjetas[activeCard];
  const cuotasDisponibles = tarjetaActiva?.cuotas || [];

  return (
    <div className="">
      <Button className="w-100" color="primary" onClick={toggleModal}>
        <i className="fa fa-credit-card-alt" aria-hidden="true"></i>
        {" Ver cuotas y medios de pago"}
      </Button>
      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Cuotas y Formas de Pago</ModalHeader>
        <ModalBody className="px-5">
          <Row>
            <Col xs={9} className="my-auto">
              <Input
                value={activeCard}
                type="select"
                onChange={(evt) => setActiveCart(parseInt(evt.target.value, 10))}
                disabled={tarjetas.length === 0}
              >
                {tarjetas.map((card, index) => (
                  <option key={`card-option-${index}`} value={index}>
                    {card.name}
                  </option>
                ))}
              </Input>
            </Col>
            <Col xs={3} className="my-1">
              {tarjetaActiva && (
                <img
                  src={tarjetaActiva.imageSrc || logo}
                  alt={tarjetaActiva.name}
                  height="40"
                  className="rounded bg-light"
                />
              )}
            </Col>
          </Row>
          <Table>
            <thead>
              <tr>
                <th>Cantidad de Cuotas</th>
                <th>Valor de Cuota</th>
                {/* <th>Intereses</th> 
                <th>Total Financiado</th>*/}
              </tr>
            </thead>
            <tbody>
              {tarjetaActiva?.name === "Tarjeta Naranja" ? (
                <Fragment>
                  <td className="text-center text-dark bg-warning" colSpan={3}>
                    <strong>Plan Z con un 12% de interes</strong>
                  </td>
                  {/* 12% con Plan Z */}
                  <td className="text-dark bg-warning">
                    <strong>{TotalFinanciado(12)}</strong>
                  </td>
                </Fragment>
              ) : (
                <Fragment></Fragment>
              )}
              {cuotasDisponibles.length > 0 ? (
                cuotasDisponibles.map((cuota, index) => (
                  <tr key={`card-${activeCard}-cuota-${index}`}>
                    <td className="pl-5">{cuota.label}</td>
                    <td className="pl-4">
                      {ValorCuota(cuota.interes, cuotasNumero(cuota))}
                    </td>
                    {/* <td>{Intereses(cuota.interes)}</td> 
                    <td>{TotalFinanciado(cuota.interes)}</td>*/}
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="text-center" colSpan={2}>
                    No hay medios de pago disponibles.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};
